import React from "react";
import { Button } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

const PaginationControls = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    if (
      i === 1 ||
      i === totalPages ||
      (i >= currentPage - 1 && i <= currentPage + 1)
    ) {
      pageNumbers.push(i);
    } else if (pageNumbers[pageNumbers.length - 1] !== "...") {
      pageNumbers.push("...");
    }
  }

  return (
    <div className="flex justify-center items-center space-x-2 mt-4">
      {/* Previous Button */}
      <Button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        sx={{
          minWidth: "30px",
          height: "30px",
          padding: "5px",
          borderRadius: "50%",
          color: "#000000", // Black text
          backgroundColor: "#FFFFFF", // White background
          "&:hover": {
            backgroundColor: "#F3F4F6", // Light gray on hover
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowBackIos fontSize="small" />
      </Button>

      {/* Page Numbers */}
      {pageNumbers.map((page, index) => (
        <Button
          key={index}
          variant="contained"
          onClick={() => typeof page === "number" && onPageChange(page)}
          sx={{
            minWidth: "30px",
            height: "30px",
            padding: "5px",
            borderRadius: "50%",
            backgroundColor: page === currentPage ? "#EA580C" : "#FFFFFF", // Orange when selected, White otherwise
            color: page === currentPage ? "#FFFFFF" : "#000000", // White text when selected, Black otherwise
            borderColor: page === currentPage ? "transparent" : "#D1D5DB",
            cursor: page === "..." ? "default" : "pointer",
            "&:hover": {
              backgroundColor: page === currentPage ? "#C2410C" : "#F3F4F6", // Darker orange on hover if selected
            },
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          disabled={page === "..."}
        >
          {page}
        </Button>
      ))}

      {/* Next Button */}
      <Button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        sx={{
          minWidth: "30px",
          height: "30px",
          padding: "5px",
          borderRadius: "50%",
          border: "none",
          color: "#000000", // Black text
          backgroundColor: "#FFFFFF", // White background
          "&:hover": {
            backgroundColor: "#F3F4F6", // Light gray on hover
          },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ArrowForwardIos fontSize="small" />
      </Button>
    </div>
  );
};

export default PaginationControls;
